module.exports = __webpack_public_path__ + "img/Transforming urban water management in India.2886ec2a.png";